import { render, staticRenderFns } from "./Total_Plays.vue?vue&type=template&id=80c13952&scoped=true"
import script from "./Total_Plays.vue?vue&type=script&lang=js"
export * from "./Total_Plays.vue?vue&type=script&lang=js"
import style0 from "./Total_Plays.vue?vue&type=style&index=0&id=80c13952&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c13952",
  null
  
)

export default component.exports